<template>
  <transition v-if="grid.data.config.isPreSearch"
              name="dialog-fade"
              @after-leave="handlePreClosed">
    <div v-show="show"
         class="data-grid-pre-search">
      <el-card>
        <div slot="header">
          <span>{{grid.data.config.title}}</span>
        </div>
        <div class="search">
          <DataGridSearchFormInput ref="gridPreSearchForm"
                                   :config="config"
                                   :grid="grid"
                                   :search-columns="searchColumns"
                                   v-bind="$attrs"
                                   @search="handlePreSearch">
          </DataGridSearchFormInput>
        </div>
        <div class="footer">
          <el-button size="mini" type="primary" @click="handlePreSearch">立即搜索</el-button>
          <el-button size="mini" type="default" @click="handlePreReset">重置条件</el-button>
        </div>
      </el-card>
    </div>
  </transition>
</template>

<script>
import DataGridDialog from './DataGridDialog'
import DataGridSearchFormInput from './DataGridSearchFormInput'
export default {
  name: 'DataGridPreSearch',
  components: {
    DataGridDialog,
    DataGridSearchFormInput
  },
  props: {
    config: {
      required: true,
      type: Object
    },
    grid: {
      required: true,
      type: Object
    },
    searchColumns: {
      type: Array
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    // 执行预搜索
    handlePreSearch () {
      this.show = false
      this.$emit('search')
    },
    // 重置预搜索
    handlePreReset () {
      let gridPreSearchForm = this.$refs.gridPreSearchForm
      if (gridPreSearchForm) {
        gridPreSearchForm.resetSearchForm()
      }
    },
    // 关闭后处理
    handlePreClosed () {
      this.$set(this.grid.data.config, 'isPreSearch', false)
    }
  },
  mounted () {
    this.show = true
  }
}
</script>

<style lang="scss">
  .data-grid-pre-search {
    position: absolute;
    left: -10px;
    top: -10px;
    right: -10px;
    bottom: -10px;
    z-index: 99;
    padding: 5% 15px;
    box-sizing: border-box;
    background-color: rgba(0,0,0,.3);
    overflow: auto;
    .el-card {
      margin: auto;
      width: 680px;
      max-width: 100%;
      box-shadow: 0 3px 6px rgba(0,21,41,.35);
      .el-card__header {
        font-size: 15px;
      }
      .el-card__body {
        padding: 0;
        background-color: #fafafa;
        .search {
          padding: 15px 0 5px;
        }
        .footer {
          height: 60px;
          background-color: #fff;
          border-top: 1px solid rgba(0,0,0,.05);
          text-align: center;
          line-height: 58px;
        }
      }
    }
  }
</style>
